<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">信息管理</el-breadcrumb-item>
      <el-breadcrumb-item><a href="/">客户信息</a></el-breadcrumb-item>
      <el-breadcrumb-item><a href="/">查看</a></el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <section class="main-body">
      <el-row :gutter="20">
        <ClientBasicInfo :teleNum="teleNum" />
      </el-row>

      <el-collapse border>
        <el-collapse-item title="病人自述" name="1">
          <SelfStatement :teleNum="teleNum" :disabled="false" />
        </el-collapse-item>
        <!-- <el-collapse-item title="病史信息" name="2">
          <MedicalHistory :teleNum="teleNum" />
        </el-collapse-item> -->
        <el-collapse-item title="基础问询" name="3">
          <BasicQuery :examUuid="examUuid"/>
        </el-collapse-item>
        <el-collapse-item title="基础检查" name="4">
          <BasicCheck :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="中医经络检测" name="5">
          <Emc :examUuid="examUuid" />
        </el-collapse-item>
      </el-collapse>
    </section>
  </div>
</template>

<script>
import { getUser, getUserExam, updateUserExam } from "../../../api/userService";
//引入病人自述 - 绝对禁忌症 与 既往病史
import ClientBasicInfo from "../../../components/common/ClientBasicInfo";
import SelfStatement from "../../../components/common/selfStatement";
// import MedicalHistory from "../../../components/common/MedicalHistory"
import BasicCheck from "../../../components/common/BasicCheck";
import BasicQuery from "../../../components/common/BasicQuery";
// import Emc from "../../../components/common/Emc"
import Emc from "../../../components/common/CCT";

export default {
  name: "clientInfo",
  components: {
    ClientBasicInfo,
    SelfStatement,
    // MedicalHistory,
    BasicQuery,
    BasicCheck,
    Emc,
  },
  data() {
    return {
      disabled:true,
      reverse: false,
      radio: "",
      //被检测人基础信息
      userInfo: {},
      //检查的总体信息-只有一项：病人自述可以用以提交更新
      overview: {
        //病人自述
        memo: "",
      },
      examUuid: "",
      teleNum: "",
    };
  },
  methods: {
    //获取用户基本信息
    _getUserInfo() {
      getUser(this.teleNum).then((res) => {
        if (res.success) {
          if (res.data) {
            //基本信息
            this.userInfo = res.data[0].userInfo;
          }
        } else {
          this.$message({ message: res.description, type: "error" });
        }
      });
    },
    //获取Exam信息
    _getUserExam() {
      // let examUuid = this.$route.query.examUuid;
      getUserExam(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data) {
            //获取病人自述
            this.overview = res.data[0];
          }
        } else {
          this.$message({ message: res.description, type: "error" });
        }
      });
    },
    //更新基础检查信息
    doUpdateUserExam() {
      updateUserExam(this.overview).then((res) => {
        this.$message({
          message: res.description,
          type: "success",
        });
        //更新用户检查数据
        this._getUserExam();
      });
    },
    
  },
  created() {
    this.examUuid = this.$route.query.examUuid;
    this.teleNum = this.$route.query.teleNum
    this._getUserInfo();
    this._getUserExam();
  },
  filters: {
    converToValueName(value) {
      if (value == "true") {
        return "是";
      } else if (value == "false") {
        return "否";
      } else if (value == "never") {
        return "从不";
      } else if (value == "occasional") {
        return "偶尔";
      } else if (value == "often") {
        return "经常";
      } else {
        return value;
      }
    },
  },
};
</script>
<style scoped>
header {
  margin-top: 30px;
}
.main-body {
  width: 80%;
  margin: 0 auto;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}

.el-col {
  border-radius: 4px;
}
.pad {
  padding-left: 40px;
}

.checkFeedbackInfo {
  margin-bottom: 10px;
}

.small-input {
  width: 40px;
}
.fullWidth {
  width: 100%;
}

.fr {
  float: right;
}
.fl {
  float: left;
}
</style>